import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import styles from './StartEvalOptions.module.css';
import { alertActions, noteActions } from '_actions'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CommonButton, RadioButton } from '_components';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { DBCheckBox, DBRadioButton, DBTextArea, DBTextField, DBDropDown } from '_components';

class PatientHomeAdmissionStartEvalOptions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            transfer: 'select',
            prepopulate: 'select',
            usePedsTemplate: true
        };
        this.handleIsPeds = this.handleIsPeds.bind(this)
    }

    handleTransferChange(event) {
        this.setState({ transfer: event.target.value });
    }

    handlePrepopulateChange(event) {
        this.setState({ prepopulate: event.target.value });
    }

    handleIsPeds(value) {
        this.setState({ usePedsTemplate: value });
    }

    transferEval() {
        if (this.state.transfer === 'select') {
            this.props.alertError('Please select an eval to transfer from.');
        } else {
            if (this.props.thurno !== null) {
                this.props.transferEvalScribe(this.props.id, this.state.transfer, this.props.aptid, this.props.adtdate, this.props.thurno, (this.state.usePedsTemplate && this.props.isPedsAge && this.props.isPedsEnabled));
            } else {
                this.props.transferEval(this.props.id, this.state.transfer, this.props.aptid, this.props.adtdate, (this.state.usePedsTemplate && this.props.isPedsAge && this.props.isPedsEnabled));
            }
        }
    }

    prepopulateEval() {
        if (this.state.prepopulate === 'select') {
            this.props.alertError('Please select an eval to prepopulate from.');
        } else {
            if (this.props.thurno !== null) {
                this.props.prepopulateEvalScribe(this.props.id, this.state.prepopulate, this.props.aptid, this.props.adtdate, this.props.thurno, (this.state.usePedsTemplate && this.props.isPedsAge && this.props.isPedsEnabled));
            } else {
                this.props.prepopulateEval(this.props.id, this.state.prepopulate, this.props.aptid, this.props.adtdate, (this.state.usePedsTemplate && this.props.isPedsAge && this.props.isPedsEnabled));
            }
        }
    }

    startBlankEval() {
        if (this.props.thurno !== null) {
            this.props.startBlankEvalScribe(this.props.id, this.props.aptid, this.props.adtdate, this.props.thurno, (this.state.usePedsTemplate && this.props.isPedsAge && this.props.isPedsEnabled));
        } else {
            this.props.startBlankEval(this.props.id, this.props.aptid, this.props.adtdate, (this.state.usePedsTemplate && this.props.isPedsAge && this.props.isPedsEnabled));
        }
    }

    render() {
        return (


            <div className={styles.option_table}>
                {this.props.isPedsAge && this.props.isPedsEnabled &&
                    <div className={styles.option_peds_wrapper}>
                        <div className={styles.prompt}>
                            Would you like to use the pediatric template?
                        </div>

                        <div className={styles.radio_container}>
                            <RadioButton
                                size='extra-small'
                                className={styles.radio_col}
                                label='Yes'
                                onClick={() => this.handleIsPeds(true)}
                                selected={this.state.usePedsTemplate === true}
                            />

                        </div>
                        <div className={styles.radio_container}>
                            <RadioButton
                                size='extra-small'
                                className={styles.radio_col}
                                label='No'
                                onClick={() => this.handleIsPeds(false)}
                                selected={this.state.usePedsTemplate === false}
                            />
                        </div>
                    </div>}

                <div className={styles.option_wrapper}>
                    <div className={styles.prompt}>
                        Please select from the following options:
                    </div>
                    <div className={styles.option_table}>
                        {Object.keys(this.props.transferEvals).length > 0 &&
                            <div className={styles.option_row}>

                                <div className={styles.option_label}>
                                    Create a note by transferring from:
                                </div>
                                <div className={styles.option_dropdown_container}>
                                    <select className={styles.option_dropdown} defaultValue="select" onChange={event => this.handleTransferChange(event)}>
                                        <option key={-1} value="select" disabled>Select an eval...</option>
                                        {Object.keys(this.props.transferEvals)
                                            .map(id => {
                                                const ev = this.props.transferEvals[id];
                                                return (
                                                    <option key={ev.noteId} value={ev.noteId}>{ev.date + ' - ' + ev.evalType + ' - ' + ev.location}</option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>
                                <div className={styles.option_dropdown_container}>
                                    <CommonButton title={'Start Note'} onClick={() => this.transferEval()} className={styles.startNoteButton}>
                                        <FontAwesomeIcon icon={faArrowRight} transform="shrink-6" color="white" />
                                    </CommonButton>
                                </div>
                            </div>
                        }
                        {Object.keys(this.props.prepopulateEvals).length > 0 &&
                            <div className={styles.option_row}>

                                <div className={styles.option_label}>
                                    Create an eval by prepopulating from:
                                </div>
                                <div className={styles.option_dropdown_container}>
                                    <select className={styles.option_dropdown} defaultValue="select" onChange={event => this.handlePrepopulateChange(event)}>
                                        <option key={-1} value="select" disabled>Select an eval...</option>
                                        {Object.keys(this.props.prepopulateEvals)
                                            .map(id => {
                                                const ev = this.props.prepopulateEvals[id];
                                                return (
                                                    <option key={ev.noteId} value={ev.noteId}>{ev.date + ' - ' + ev.evalType + ' - ' + ev.location}</option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>
                                <div className={styles.option_dropdown_container}>
                                    <CommonButton title={'Start Note'} onClick={() => this.prepopulateEval()} className={styles.startNoteButton} >
                                        <FontAwesomeIcon icon={faArrowRight} transform="shrink-6" color="white" />
                                    </CommonButton>
                                </div>
                            </div>
                        }
                        {((this.props.status ? this.props.status : -1) !== 8) &&
                            <div className={styles.option_row}>
                                <div className={styles.option_label}>
                                    Start a blank eval
                                </div>
                                <div className={styles.option_dropdown_container}>
                                    <CommonButton title={'Start Note'} onClick={() => this.startBlankEval()} className={styles.startNoteButton}>
                                        <FontAwesomeIcon icon={faArrowRight} transform="shrink-6" color="white" />
                                    </CommonButton>
                                </div>
                            </div>}
                    </div>

                </div>
                <span title="Clear Options" className={styles.close} onClick={() => { this.props.clearOptions({ epno: this.props.id }) }}>
                    <FontAwesomeIcon icon={faTimesCircle} />
                </span>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearOptions: bindActionCreators(noteActions.startNoteEvalOptionsClear, dispatch),
        transferEval: bindActionCreators(noteActions.transferEval, dispatch),
        prepopulateEval: bindActionCreators(noteActions.prepopulateEval, dispatch),
        startBlankEval: bindActionCreators(noteActions.startBlankEval, dispatch),
        transferEvalScribe: bindActionCreators(noteActions.transferEvalScribe, dispatch),
        prepopulateEvalScribe: bindActionCreators(noteActions.prepopulateEvalScribe, dispatch),
        startBlankEvalScribe: bindActionCreators(noteActions.startBlankEvalScribe, dispatch),
        alertError: bindActionCreators(alertActions.error, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    let transferEvals = Object.keys(state.entities.transferEvals)
        .filter(key => { return state.entities.transferEvals[key].epno === ownprops.id })
        .sort((a, b) => new Date(state.entities.transferEvals[b].date).getTime() > new Date(state.entities.transferEvals[a].date).getTime() ? -1 : 1)
        .map(key => state.entities.transferEvals[key]);
    let prepopulateEvals = Object.keys(state.entities.prepopulateEvals)
        .filter(key => { return state.entities.prepopulateEvals[key].epno === ownprops.id })
        .sort((a, b) => new Date(state.entities.prepopulateEvals[b].date).getTime() > new Date(state.entities.prepopulateEvals[a].date).getTime() ? -1 : 1)
        .map(key => state.entities.prepopulateEvals[key]);
    let epno = ownprops.id;

    let isPedsAge = state.entities.admissions[epno].isPedsAge;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;

    return {
        transferEvals,
        prepopulateEvals,
        aptid: state.ui.admissions[ownprops.id].aptid,
        adtdate: state.ui.admissions[ownprops.id].adtdate,
        thurno: ownprops.thurno ? ownprops.thurno : null,
        isPedsAge,
        isPedsEnabled,
        epno
    };
}

const connectedPatientHomeAdmissionStartEvalOptions = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionStartEvalOptions);
export { connectedPatientHomeAdmissionStartEvalOptions as PatientHomeAdmissionStartEvalOptions };

